import { FC, useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TypeAheadField from '../../typeAheadField/TypeAheadField';
import usePrevious from '../../../../hooks/usePrevious';
import useTagMutations from '../../../domain/tag/useTagMutations';
import { TypeAheadSearchOption } from '../../typeAheadField/TypeAheadField.styles';
import { TagsSelectFieldProps } from './TagsSelectField.types';

const TagsSelectField: FC<TagsSelectFieldProps> = ({
  name,
  saveOnChange,
  saveOnChangeParams,
  successCallback,
  placeHolder,
  ...props
}) => {
  const { t } = useTranslation();
  const { resetField } = useForm();
  const tags = useWatch({ name });
  const prevTags = usePrevious(tags);
  const { addTag, deleteTag } = useTagMutations();

  useEffect(() => {
    if (saveOnChange && tags) {
      // @ts-expect-error TS2339 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      const { entityUid, tagType } = saveOnChangeParams;

      const tagsToAdd = tags.filter(
        // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
        ({ name: tagName }) =>
          prevTags &&
          !prevTags.find(
            // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
            ({ name: existingTagName }) => existingTagName === tagName,
          ),
      );

      const tagsToDelete = prevTags?.filter(
        // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
        ({ name: tagName }) =>
          !tags.find(
            // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
            ({ name: existingTagName }) => existingTagName === tagName,
          ),
      );

      const successCallbackReset = () => {
        resetField(name, { defaultValue: tags });
        successCallback?.();
        // TODO reset cached query
      };

      // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      tagsToAdd?.forEach(({ name: tag }) => {
        addTag({
          entityUid,
          tag,
          tagType,
          successCallback: successCallbackReset,
        });
      });

      // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      tagsToDelete?.forEach(({ name: tag }) => {
        deleteTag({
          entityUid,
          tag,
          tagType,
          successCallback: successCallbackReset,
        });
      });
    }
  }, [tags]);

  if (saveOnChange && !saveOnChangeParams) {
    throw new Error(
      'Invalid argument: "saveOnChangeParams" must be provided when "saveOnChange" is set to true',
    );
  }

  return (
    <TypeAheadField
      allowNew
      labelKey="name"
      multiple
      name={name}
      newSelectionPrefix={t('componentTag.addNewTagPrefix')}
      placeholder={placeHolder || t('componentTag.addTagPlaceholder')}
      placeholderAlwaysVisible
      renderMenuItemChildren={({ name: tag }) => (
        <TypeAheadSearchOption>{tag}</TypeAheadSearchOption>
      )}
      selected={tags}
      saveOnEnter
      {...props}
    />
  );
};

export default TagsSelectField;
